<script>
export default {
	lang: 'shop',
	props: {
		order: Object,
	},
	computed: {
		paymentData() {
			return this.order.payments[0].data || {}
		},
	},
}
</script>
<template>
	<div class="px-4 font-1">
		<div class="font-2">{{ paymentData.title }}</div>
		<div class="mb-2">{{ paymentData.description }}</div>
		<div class="pb-1 font-2 d-flex align-center">
			<b class="mr-2">{{ paymentData.qty }}x </b>
			<PriceText
				:amount="paymentData.installmentsAmount"
				zero-decimals
				:sup-decimals="false"
				:currency="order.currency.sign"
			/>
		</div>
		<div class="pb-1 grey--text text--darken-2 d-flex align-center" v-if="paymentData.qty > 1">
			<span class="mr-2">{{ 'Total' | lang }}</span>
			<PriceText
				:amount="paymentData.total"
				zero-decimals
				:sup-decimals="false"
				:currency="order.currency.sign"
			/>
		</div>
	</div>
</template>

